<template>
  <div class="page">
    <div class="bdpage">
      <div class="bdblocks">
        <div v-for="(item,index) in bdBlocks" :key="index">
          <div class="blockItem flexCenter" :class="'blockItem'+index" @click="checkBlock(item)">
            <div class="time">{{ item.table_name }}</div>
            <div v-if="item.table_detail" class="checked"></div>
            <div v-if="item.table_detail" class="thumbnail flexCenter">
              <div class="flexCloumnSingleCenter">
                <img :src="'./images/yy_img/time_checked.png'" alt="">
                <div class="text">已填写</div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <!--预约须知-->
    <van-popup v-model="isShowModal" :close-on-click-overlay="false">
      <div class="modalImg">
        <img :src="'./images/gxyzz_img/block_0_dialog.png'" alt="">

        <div class="pos flexCenter">
          <div class="btn" @click="closeDialog">继续填写</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Toast
} from 'vant';
export default {

  data() {
    return {
      pmid: 0,
      openid:'',
      stu_id:0,
      bdBlocks:[],
      ckdId:null,
      isShowModal: false,
      tableInfo:{},
      isRead:false,
    }
  },
  beforecreate(){
    this.isShowModal = false
  },
  mounted() {
    // console.log('$route.query', this.$route.query)
    $(".page").height($(window).height())
    document.title = "新生报道"
    this.pmid = this.$route.query.pmid
    this.openid = this.$route.query.openid
    this.stu_id = this.$route.query.stu_id

    // this.pmid = 5
    // this.openid = 'oWsp85Bz3tDnWAC280W9bHMnUNcA'
    // this.stu_id = 5107

    window.pmid = this.pmid
    window.openid = this.openid
    window.stu_id = this.stu_id

    this.getList()
  },
  beforeDestroy(){
    this.isShowModal = false
  },
  methods: {
    getList() {
      this.$http.post('/api/t_stu_check_in_table_list',{
        pmid:this.pmid,
        stu_id:Number(this.stu_id)
      }).then(res => {
        this.bdBlocks = res.data.data
      })
    },
    checkBlock(item) {
      let _this = this
      // console.log(item)
      if(item.table_name.indexOf('身体状况')!=-1){
        item.shortMatch = '身体状况'
      }
      if(item.table_name.indexOf('校服')!=-1){
        item.shortMatch = '校服'
      }
      if(item.table_name.indexOf('学生信息')!=-1){
        item.shortMatch = '学生信息'
      }
      if(item.table_name.indexOf('个人信息')!=-1){
        item.shortMatch = '个人信息'
      }
      if(item.table_name.indexOf('其他信息')!=-1){
        item.shortMatch = '其他信息'
      }
      if(item.table_name.indexOf('住宿')!=-1){
        item.shortMatch = '住宿'
      }
      this.tableInfo = {...item}
      console.log(this.tableInfo)
      this.asyncLocalStorage.setItem('tableInfo',JSON.stringify(item)).then(r=>{
        if(item.table_name.indexOf('身体状况')!=-1){
          if(!_this.isRead){
            _this.isShowModal = true
          }else {
            _this.goOn(item.shortMatch)
          }
        } else {
          _this.goOn(item.shortMatch)
        }
      })

    },
    goOn(shortMatch){
      console.log(shortMatch)
      let _this = this
      _this.isShowModal = false
      let  params = {
        item:_this.tableInfo,
        stu_id:_this.stu_id,
        pmid:_this.pmid,
      }

      if(shortMatch == '身体状况'){
        this.$router.push({name:'bd_health', params: params})
      }
      if(shortMatch == '校服'){
        this.$router.push({name:'bd_uniform', params: params})

      }
      if (shortMatch == '学生信息') {
        this.$router.push({name:'bd_stuInfo', params: params})

      }
      if (shortMatch == '个人信息') {
        this.$router.push({name:'bd_perInfo', params: params})

      }
      if (shortMatch == '其他信息') {
        this.$router.push({name:'bd_otherInfo', params: params})

      }
      if (shortMatch == '住宿') {
        this.$router.push({name:'bd_dorm', params: params})

      }
    },
    closeDialog(){
      this.isRead=true
      this.isShowModal = false
      this.goOn('身体状况')
    }
  },
}
</script>

<style lang="less" type="text/less">
.page{
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}
.bdpage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
  background-image: url(../../../../public/images/gxyzz_img/bd_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 6vh 0 12vh 0;
  .bdblocks {
    width: 100%;
    height: 100%;
    padding: 0 8vw;
    display: flex;
    box-sizing: border-box;
    overflow-y: scroll;
    justify-content: space-between;
    flex-wrap: wrap;
    .blockItem0{background-image: url(../../../../public/images/gxyzz_img/bd_block_0.png);}
    .blockItem1{background-image: url(../../../../public/images/gxyzz_img/bd_block_1.png);}
    .blockItem2{background-image: url(../../../../public/images/gxyzz_img/bd_block_2.png);}
    .blockItem3{background-image: url(../../../../public/images/gxyzz_img/bd_block_3.png);}
    .blockItem4{background-image: url(../../../../public/images/gxyzz_img/bd_block_4.png);}
    .blockItem5{background-image: url(../../../../public/images/gxyzz_img/bd_block_5.png);}
    .blockItem {
      background-color: transparent;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 38vw;
      height: 30vh;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 6px;
      margin-bottom: 3.37vh;
      position: relative;

      .time {
        color: #1285FE;
        font-size: 19px;
        font-weight: 700;
        text-align: center;
      }
    }

    .checked {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #8fcfff;
      opacity: 0.8;
      border-radius: 6px;
    }

    .thumbnail {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      img {
        display: inline-block;
        width: 23%;
      }
      .text{
        margin-top: 20px;
        color: #FF006C;
        font-size: 24px;
        font-weight: 700;
      }
    }

    .disabled {
      position: absolute;
      z-index: 3;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: gray;
      opacity: 0.5;
      border-radius: 6px;
    }
  }

  .submitBtn {
    width: 100%;
    height: 10vh;

    .btn {
      width: 50%;
      padding: 1.4vh 0;
      background-color: #00CFDC;
      color: #fff;
      font-size: 15px;
      border-radius: 5vw;
    }
  }
}
.van-popup {
  background-color: transparent;
}
.modalImg {
  display: inline-block;
  width: 74vw;
  position: relative;

  img {
    display: inline-block;
    width: 100%;
  }

  .pos {
    position: absolute;
    bottom: 1vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 0.4vh 5%;
      color: #fff;
      font-size: 15px;
      border-radius: 5vw;
      border: 1px solid #fff;
    }
  }
}

</style>
